import { useEffect } from "react";
import useModals from "../../../hooks/useModals";
import AddJobOffer from "../modals/AddJobOffer";
import { useSettingsStore } from "../../../stores/settings";
import { showToastError } from "../../../services/toast";
import DeleteModal from "../../ui/modals/DeleteModal";
import { getJobsOpenings } from "../../../api/jobsOpenings";

const Recrutement = () => {
  const { jobOffers, setJobOffers, updateSettings } = useSettingsStore();

  const { modals, openModals, openModal, closeModal } = useModals();

  useEffect(() => {
    getJobsOpenings()
      .then((res) => {
        setJobOffers(res.data);
      })
      .catch((err) => {
        showToastError(err.response.data.message);
      });
  }, [updateSettings]);

  return (
    <div className="flex flex-col gap-5">
      {Object.keys(modals).map((modalId) =>
        openModals[modalId] ? <div key={modalId}>{modals[modalId]}</div> : null,
      )}

      {/* En-tête */}
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between rounded-2xl border border-slate-200 bg-white px-5 py-4 shadow-sm">
        <div className="min-w-0">
          <p className="text-[11px] font-bold tracking-wider text-slate-400 uppercase">
            Recrutement
          </p>
          <h2 className="mt-1 text-xl font-bold tracking-tight text-slate-900">
            Offres d'emplois
          </h2>
          <p className="mt-1 font-Nunito text-sm text-slate-500">
            Gérez vos offres d'emplois et mettez-les à jour en quelques clics.
          </p>
        </div>
        <button
          type="button"
          onClick={() =>
            openModal(
              "addJobOffer",
              <AddJobOffer
                closeModal={() => closeModal("addJobOffer")}
                update={false}
                id={undefined}
              />,
            )
          }
          className="inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 rounded-xl bg-light-red px-4 py-2.5 font-Nunito text-sm font-semibold text-white shadow-sm transition-all duration-200 hover:opacity-90 hover:shadow-md hover:shadow-light-red/20 focus-visible:ring-2 focus-visible:ring-light-red/40 focus-visible:outline-none"
        >
          Ajouter une offre d'emploi
          <svg aria-hidden="true" className="size-4" fill="none" stroke="currentColor" strokeWidth={2.2} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 5v14m-7-7h14" />
          </svg>
        </button>
      </div>

      {/* Liste */}
      <div className="rounded-2xl border border-slate-200 bg-white shadow-sm overflow-hidden">
        <div className="max-h-[60vh] overflow-y-auto divide-y divide-slate-100">
          {jobOffers.length > 0 ? (
            jobOffers.map((offer) => (
              <div
                key={offer.id}
                className="flex flex-wrap items-center justify-between gap-4 px-5 py-4 transition-colors hover:bg-slate-50"
              >
                <div className="min-w-0">
                  <p className="font-Nunito text-sm font-semibold text-slate-900">
                    {offer.title}
                  </p>
                  <p className="mt-0.5 text-xs text-slate-400">
                    Offre n°{offer.id}
                  </p>
                </div>
                <div className="flex flex-wrap items-center gap-2">
                  <button
                    type="button"
                    className="inline-flex cursor-pointer items-center justify-center gap-1.5 rounded-xl border border-slate-200 bg-white px-3.5 py-2 font-Nunito text-sm font-semibold text-slate-700 shadow-sm transition-colors hover:border-slate-300 hover:bg-slate-50 focus-visible:ring-2 focus-visible:ring-slate-300 focus-visible:outline-none"
                    onClick={() =>
                      openModal(
                        "addJobOffer",
                        <AddJobOffer
                          closeModal={() => closeModal("addJobOffer")}
                          update={true}
                          id={offer.id}
                        />,
                      )
                    }
                  >
                    Modifier
                  </button>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      openModal(
                        "deleteModal",
                        <DeleteModal
                          closeModal={() => closeModal("deleteModal")}
                          id={offer.id}
                        />,
                      );
                    }}
                    className="inline-flex cursor-pointer items-center justify-center gap-1.5 rounded-xl bg-light-red px-3.5 py-2 font-Nunito text-sm font-semibold text-white shadow-sm transition-all duration-200 hover:opacity-90 hover:shadow-md hover:shadow-light-red/20 focus-visible:ring-2 focus-visible:ring-light-red/40 focus-visible:outline-none"
                  >
                    Supprimer
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div className="flex flex-col items-center justify-center py-12 text-slate-400">
              <svg className="size-12 mb-3 opacity-40" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2M3.5 8h17a1.5 1.5 0 011.5 1.5v8a1.5 1.5 0 01-1.5 1.5h-17A1.5 1.5 0 012 17.5v-8A1.5 1.5 0 013.5 8z" />
              </svg>
              <p className="font-Nunito text-sm font-medium text-slate-500">Aucune offre d'emploi trouvée</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Recrutement;
